import React from 'react';

import { ThemeProvider, ThemedGlobalStyle } from '@/theme';
import { RouterProvider } from '@/providers/router.provider';
import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { Toaster } from "react-hot-toast";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 24 * 60 * 1000,
      refetchOnWindowFocus: false,
      gcTime: 60 * 24 * 60 * 1000,
      refetchOnMount: false,
      refetchIntervalInBackground: false,
      refetchInterval: false,
      refetchOnReconnect: false
    }
  }
});

const asyncStoragePersister = createAsyncStoragePersister({
  storage: window.localStorage
});

export const App = () => {
  return (
        <ThemeProvider>
          <ThemedGlobalStyle />
          <PersistQueryClientProvider
            client={queryClient}
            persistOptions={{
              persister: asyncStoragePersister,
              dehydrateOptions: {
                shouldDehydrateQuery: (query: any) => {
                  return !!query?.meta?.persist;
                }
              }
            }}
          >
     
              <Toaster
										toastOptions={{
											style: {
												borderRadius: "10px",
												background: "#333",
												color: "#fff",
											},
										}}
									/>
              <RouterProvider />
         
          </PersistQueryClientProvider>
        </ThemeProvider>

  );
};
